/* eslint-disable no-const-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
    Card,
} from "reactstrap";
import { ColorRange } from "./HeatmapCharts";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { POST_TABLE_SEAT_OPTIMIZATION } from "../../helpers/data_helper";
import Loader from "../../Components/Common/Loader";
import { getDateByName, generateHourBlocks, normalizeChartData } from "../../helpers/api_helper";

const TableOccChart = ({ activeDate, customDate, mealPeriod, filtermealperiod }) => {
    const [occupancyHeatmapData, setOccupancyHeatmapData] = useState({
        table: [],
        seat: [],
        revPASH: [],
    });
    const [occupancyHeatmapAjax, setOccupancyHeatmapAjax] = useState(true);

    useEffect(() => {

        // Create a Date object from the original date string
        var originalDate = new Date(customDate[0]);

        // Extract the year, month, and day from the Date object
        var year = originalDate.getFullYear();
        var month = (originalDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based, so add 1
        var day = originalDate.getDate().toString().padStart(2, '0');

        // Create the formatted date string
        var datefrom = year + '-' + month + '-' + day;

        // Create a Date object from the original date string
        var originalDate2 = new Date(customDate[1]);

        // Extract the year, month, and day from the Date object
        var year2 = originalDate2.getFullYear();
        var month2 = (originalDate2.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based, so add 1
        var day2 = originalDate2.getDate().toString().padStart(2, '0');

        // Create the formatted date string
        var dateto = year2 + '-' + month2 + '-' + day2;

        let dateval = activeDate.value === "Custom" ? { from: datefrom, to: dateto } : getDateByName(activeDate.value);

        if (
            activeDate.value !== "Custom" ||
            (activeDate.value === "Custom" && customDate[0] && customDate[1])
        ) {
            // setTableRevenueAjax(true);
            setOccupancyHeatmapAjax(true);
            var dateFilter =
                activeDate.value === "Custom"
                    ? { from: customDate[0], to: customDate[1] }
                    : getDateByName(activeDate.value);
            const controller = new AbortController();
            postDataAPI({
                dateFilter: dateval,
                mealPeriod: mealPeriod,
                serviceName: POST_TABLE_SEAT_OPTIMIZATION.serviceName,
                op: POST_TABLE_SEAT_OPTIMIZATION.occupancy_heatmap_op,
            }, controller.signal).then((response) => {
                setOccupancyHeatmapAjax(false);
                if (response.status === "ok") {
                    //setOccupancyHeatmapData(response.data);
                    const selectedPeriod = filtermealperiod.find(
                        (item) => item.sp_id == mealPeriod
                    );

                    let fullHourBlocks = [];
                    if (selectedPeriod) {
                        fullHourBlocks = generateHourBlocks(
                            selectedPeriod.start_time,
                            selectedPeriod.end_time
                        );
                    } else {
                        // Default 00:00 - 23:00
                        fullHourBlocks = generateHourBlocks("00:00:00", "23:00:00");
                    }

                    // Normalize each key (seat, table, revPASH)
                    const normalizedData = {
                        // seat: normalizeChartData(response.data.seat || [], fullHourBlocks),
                        table: normalizeChartData(response.data.table || [], fullHourBlocks).reverse(),
                        seat: response.data.seat,
                        revPASH: response.data.revPASH
                    };

                    setOccupancyHeatmapData(normalizedData);
                } else {
                    console.log(response);
                }
            });
            return () => {
                controller.abort();
            };
        }
    }, [activeDate, customDate, mealPeriod, filtermealperiod]);


    return (
        <Card>
            <div className="card-header px-2">
                <div className="d-flex align-items-start">
                    <div className={`icon-box rounded bg-danger text-white`}>
                        <i className="ri-bar-chart-fill"></i>
                    </div>
                    <div className="ps-2">
                        <h4 className="card-title mb-1">
                            Table Occupancy
                        </h4>
                        <p className="text-muted mb-0">
                            Hourly table occupancy heatmap highlighting demand levels from very low to very high.
                        </p>
                    </div>
                </div>
            </div>
            <div id="TableOccChart" className="card-body px-2">
                {occupancyHeatmapAjax && <Loader />}
                <div
                    className={occupancyHeatmapAjax ? "opacity-0" : ""}
                >
                    <ColorRange
                        dataSeries={occupancyHeatmapData.table}
                        dataText="Average Occ"
                        dataColors='["--vz-primary", "--vz-danger", "--vz-success", "--vz-warning", "--vz-info", "--vz-dark"]'
                    />
                </div>
            </div>
        </Card>
    );
};

export default TableOccChart;
